export default __webpack_public_path__ + "static/media/diam.c83a71d3.svg";